import './App.css'
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {MainLaoyut} from "./Layuots/DashboardLayout/MainLayout.tsx";
import {Home} from "./Pages/Home/Home.tsx";
import {AboutUs} from "./Pages/Home/AboutUs/AboutUs.tsx";
import {QualityPolicy} from "./Pages/Home/QualityPolicy/QualityPolicy.tsx";
import {Contact} from "./Pages/Contact/Contact.tsx";
import {Prices} from "./Pages/Prices/Prices.tsx";
import {News} from "./Pages/News/News.tsx";
import {Gallery} from "./Pages/Gallery/Gallery.tsx";
import {Cooperation} from "./Pages/Cooperation/Cooperation.tsx";
import {PIT} from "./Pages/PIT/PIT.tsx";
import {useEffect, useState} from "react";
import { HelmetProvider } from 'react-helmet-async';
import NewsAdmin from "./Pages/News/SubPage/NewsAdmin.tsx";
import Config from './config.tsx';

function App() {

//    Endpointy

const [photos, setPhotos] = useState<string[]>([]);
const [certificates, setCertificates] = useState<string[]>([]);

useEffect(() => {
  fetch(`${Config.API_URL}/assets`)
    .then(res => res.json())
    .then(data => {
      setCertificates(shuffleArray(data.certs));
      setPhotos(shuffleArray(data.photos));
    })
    .catch(error => {
      console.error('Błąd podczas pobierania danych assets:', error);
    });
}, []);


  const shuffleArray = (array: string[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

//Koniec endpointów

  return (
      <HelmetProvider>
        <Router>
            <MainLaoyut>
                <Routes>
                    {/*Example użycia*/}
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/qualitpolicy" element={<QualityPolicy />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/prices" element={<Prices />} />
                    <Route path="/news" element={<News />} />
                    <Route path="/news_zadmin" element={<NewsAdmin />} />
                    <Route path="/gallery" element={<Gallery certs={certificates} photos={photos}/>} />
                    <Route path="/cooperation" element={<Cooperation />} />
                    <Route path="/pit" element={<PIT />} />
                </Routes>
            </MainLaoyut>
        </Router>
      </HelmetProvider>
  )
}

export default App
